















































































































































































































// import { defineComponent } from '@vue/composition-api'
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
const qualityPounts = () => import("./commpon/qualityPoints.vue");
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityRuleListReq,
  Bool,
  OpenTicketReq,
  AudioQualityRuleData,
  SaveAudioQualityRuleReq,
  GetAudioQualityOptionReq,
  GetAudioQualityScriptListReq,
  AudioQualityScriptData,
  GetAudioQualityTplReq,
  QualityPoint,
  ScriptPoint,
  RepeatScript,
  GetTicketListParamReq,
  SaveAudioQualityTplReq,
  AudioQualityTplData,
  AudioQualityScope,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";
@Component({
  name: "addNewRules",
  components: {
    qualityPounts,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private Scoring: any = "";
  @Provide() private numberofmatches: any = "";
  @Provide() private isSaveAudioQualityRuleLoding: boolean = false;
  @Provide() private num: any = "";
  @Provide() private teleOptions: any = [];
  @Provide() private nxteleOptions: any = [];
  @Provide() private nxteleOptionsPoint: any = [];
  @Provide() private QCPointTypeList: any = [];
  @Provide() private qualityobjectmapMap: any = [];
  @Provide() private selectName: any = "";
  @Provide() private tableDisable: boolean = false;
  @Provide() private ScoringOptions: any = [
    { id: "1", val: "dashbordDy.AddPoints" },
    { id: "2", val: "dashbordDy.MinusPoints" },
  ];
  @Provide() private ApplicableaccountperiodOP: any = [];
  @Provide() private ruleNameOptions: any = [];

  @Provide() private resultData: any = [
    {
      ruleName: [],
      scoring: "",
      score: "",
      RulesDescription: "",
      tableDisable: false,
      status: "",
    },
  ];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private userPageIndex: number = 1;
  @Provide() private userPagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private resultOptions: any = "";
  @Provide() private addNewList: any = [1];
  @Provide() private radio: any = "2";
  @Provide() private lastresultData: any = [];
  @Provide() private indextab: number = 0;

  @Provide() private ruleId: number = 0;
  @Provide() private userForm: any = {
    templateName: null,
    TemplateDescription: null,
    Applicableaccountperiod: "",
    talkTime: null,
  };
  private created() {
    if (this.$route.query.id) {
      this.GetAudioQualityRuleReq(this.$route.query.id);
      this.getTicketList(false);
      this.getTicketListParam();
    } else {
      this.getTicketList(false);
      this.getTicketListParam();
    }
  }

  //  进入页面调取，查询需要的select下拉框
  private getTicketListParamFuc(data: any) {
    this.ApplicableaccountperiodOP = data.ticketitemList;
  }
  private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  //获取规则列表
  private getTicketList(falg: any) {
    let request: any = new GetAudioQualityRuleListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(0, 999));
    let requestAuto: any = new AudioQualityRuleData();
    requestAuto.setId();
    requestAuto.setRulename(); //(this.ruleForm.ruleName).toString()
    requestAuto.setRuletext();
    requestAuto.setScorepolicy();
    requestAuto.setScore();
    requestAuto.setUsername();
    requestAuto.setPointnum();
    requestAuto.setCtime();
    requestAuto.setStatus();
    request.setData(requestAuto);
    ticketClient.getAudioQualityRuleList(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (falg) {
            let _fuc = this.getRoleListAPIFucII;
            handleResponse(data, _fuc);
          } else {
            let _fuc = this.getRoleListAPIFuc;
            handleResponse(data, _fuc);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
  private getRoleListAPIFuc(data: any) {
    if (data.listList) {
      data.listList.map((item: any) => {
        if (item.status == 1) {
          this.ruleNameOptions.push({ id: item.id, val: item.rulename });
        }
      });
    }
  }
  private getRoleListAPIFucII(data: any) {
    if (data.listList) {
      data.listList.map((item: any, o: any) => {
        if (this.selectName == item.id) {
          this.$set(this.resultData, this.indextab, {
            ruleName: item.id,
            ruleNameid: item.id,
            scoring: item.scorepolicy + "",
            score: item.score,
            RulesDescription: item.ruletext,
            status: item.status,
            tableDisable: false,
          });
        }
      });
    }
  }
  //selectruleName
  private selectruleName(val: any, index: any) {
    this.selectName = val;
    this.indextab = index;
    this.getTicketList(true);
  }

  //保存
  private addNewPoint(index: any, row: any) {
    this.lastresultData = [];
    this.resultData.forEach((item: any) => {
      if (item.tableDisable) {
        this.lastresultData.push(item);
      }
    });
    let arr: any = [];
    if (row.ruleName && row.score && row.scoring) {
      this.lastresultData.forEach((item: any) => {
        if (row.ruleName == item.ruleName) {
          arr.push({ index: false });
        } else {
          arr.push({ index: true });
        }
        //   if (row.ruleName !== item.ruleName) {
        //     this.$set(this.resultData, index, {
        //       ruleName: row.ruleName,
        //       scoring: row.scoring + "",
        //       score: row.score,
        //       RulesDescription: row.RulesDescription,
        //       status: row.status,
        //       tableDisable: true,
        //     });
        //   } else {
        //     this.$message({
        //       type: "error",
        //       message: "dont choose the same rule!",
        //     });
        //   }
      });
      if (arr.findIndex((index: any) => index.index === false) === -1) {
        this.$set(this.resultData, index, {
          ruleName: row.ruleName,
          ruleNameid: row.ruleNameid,
          //   ruleName: this.ruleNameOptions
          //   ? rArr.indexOf(item.id) == -1
          //     ? item.rulename
          //     : item.id
          //   : item.rulename, //item.realname
          // ruleNameid: item.id,
          scoring: row.scoring + "",
          score: row.score,
          RulesDescription: row.RulesDescription,
          status: row.status,
          tableDisable: true,
        });
      } else {
        this.$message({
          type: "error",
          message: this.$tc("dashbordDy.scoreisrepeated"), // "dont choose the same rule!",
        });
      }
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
    }
  }

  private addQCpoint() {
    // this.lastresultData = this.resultData;

    this.resultData.push({
      index: this.resultData.length + 1,
      tableDisable: false,
    });
    // this.resultData = this.lastresultData.concat({
    //   index: this.resultData.length + 1,
    // });
  }
  private getMyEvent(index: any, rows: any) {
    rows.splice(index, 1);
    // this.lastresultData = this.resultData;
  }
  private selectRole() {}
  private getRuleReqAPIFuc(data: any) {
    this.userForm.templateName = data.data.tplname;
    this.userForm.TemplateDescription = data.data.tpltext;
    this.userForm.Applicableaccountperiod = data.data.scope.itemid
      ? data.data.scope.itemid + ""
      : "";
    this.userForm.talkTime = data.data.scope.duration
      ? data.data.scope.duration
      : "";
    let arr: any[] = [];
    let rArr: any[] = [];
    if (this.ruleNameOptions) {
      this.ruleNameOptions.forEach((i: any) => {
        rArr.push(i.id);
      });
    }
    data.data.rulelistList.forEach((item: any) => {
      arr.push({
        ruleName: this.ruleNameOptions
          ? rArr.indexOf(item.id) == -1
            ? item.rulename
            : item.id
          : item.rulename, //item.realname
        ruleNameid: item.id,
        scoring: item.scorepolicy + "",
        score: item.score,
        RulesDescription: item.ruletext,
        tableDisable: true,
      });
    });
    this.resultData = arr;
    // this.tableDisable=true
  }
  //获取反显详情
  private async GetAudioQualityRuleReq(id: any) {
    let request = new GetAudioQualityTplReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(0, 0));
    request.setId(Number(id));
    await ticketClient.getAudioQualityTemplate(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRuleReqAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  //获取下拉列表
  private AudioQualityOptionReq() {
    let request = new GetAudioQualityOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getAudioQualityOption(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRoleListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {

          errorMsg(err);
        }
      }
    );
  }

  private testSaveAudioQualityRule() {
    if (this.userForm.templateName && this.resultData.length > 0) {
      if ((this.userForm.templateName + "").length > 15) {
        this.$message({
          type: "error",
          message: "pls check the form value less then 15!",
        });
        this.isSaveAudioQualityRuleLoding = false;
        return false;
      }
      if (this.userForm.TemplateDescription) {
        if (this.userForm.TemplateDescription.length >= 150) {
          //   return true;
          // } else {
          this.$message({
            type: "error",
            message: "pls check the form value less then 150!",
          });
          this.isSaveAudioQualityRuleLoding = false;

          return false;
          // }
        }
      }

      let a: any[] = [];
      this.resultData.forEach((item: any, index: any) => {
        if (item.tableDisable && item.tableDisable == true) {
          return a.push({ index: true });
        } else if (item.tableDisable && item.tableDisable == false) {
          return a.push({ index: false });
        } else {
          return a.push({ index: false });
        }
      });

      if (a.findIndex((index: any) => index.index === false) === -1) {

        return true;
      } else {
        this.$message({
          type: "error",
          message: "pls check the form value!",
        });
        this.isSaveAudioQualityRuleLoding = false;
        return false;
      }
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
      this.isSaveAudioQualityRuleLoding = false;

      return false;
    }
  }
  //保存
  private SaveAudioQualityRule() {
    this.isSaveAudioQualityRuleLoding = true;
    if (this.testSaveAudioQualityRule()) {
      let request = new SaveAudioQualityTplReq();
      request.setCommonin(setCommon());
      request.setId(Number(this.$route.query.id));
      let requestAuto = new AudioQualityTplData();
      requestAuto.setId(Number(this.$route.query.id)); // mobanID
      requestAuto.setTplname(this.userForm.templateName); // mobanID
      requestAuto.setTpltext(this.userForm.TemplateDescription); // mobanID
      let req = new AudioQualityScope();
      req.setDuration(this.userForm.talkTime);
      req.setItemid(this.userForm.Applicableaccountperiod);
      requestAuto.setScope(req); // mobanID
      let arr: any[] = [];
      this.resultData.forEach((item: any, index: any) => {
        let requestThree = new AudioQualityRuleData(); // QualityPoint
        //    requestThree.setRulename(this.userForm.ruleName)// 规则名称
        requestThree.setRuletext(item.RulesDescription); // 规则描述说明
        requestThree.setScorepolicy(item.scoring); // 评分方法 加分/减分
        requestThree.setScore(item.score); // 分值
        requestThree.setId(item.ruleNameid); // 质检点序号
        requestThree.setStatus(1); // 状态
        arr.push(requestThree);
      });
      requestAuto.setRulelistList(arr);
      requestAuto.setStatus(1); // 状态
      request.setData(requestAuto);
      ticketClient.saveAudioQualityTemplate(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            if (data.commonout.code == 0) {
              this.$message.success("success");
              this.isSaveAudioQualityRuleLoding = false;
            } else {
              this.isSaveAudioQualityRuleLoding = false;
              this.$message.error(data.commonout.errmsg);
            }
          }
          if (err) {
            this.isSaveAudioQualityRuleLoding = false;
            errorMsg(err);
          }
        }
      );
    }
    // else {
    //   this.$message({
    //     type: "error",
    //     message: "pls check the form value!",
    //   });
    //   this.isSaveAudioQualityRuleLoding = false;
    // }
  }
}
